import { render, staticRenderFns } from "./HeaderForSection.vue?vue&type=template&id=edda225a&"
import script from "./HeaderForSection.vue?vue&type=script&lang=js&"
export * from "./HeaderForSection.vue?vue&type=script&lang=js&"
import style0 from "./HeaderForSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports